import { TouchableOpacity, StyleSheet } from "react-native";
import VText from "./../VText";
import { Svg as Svgs } from "assets/svg";
import ImageView from "../../../src/image";
import AppleLogin from "react-apple-login";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";

const AppleAuth = ({ onSuccess }) => {
  const handleAppleLogin = (response) => {
    if (response?.authorization?.id_token) {
      onSuccess(response);
    } else {
    }
  };

  return (
    <AppleLogin
      clientId={process.env.EXPO_PUBLIC_APPLE_CLIENT_ID}
      redirectURI={process.env.EXPO_PUBLIC_APPLE_REDIRECT_URI}
      scope="name email"
      usePopup={true}
      responseType="id_token"
      callback={handleAppleLogin}
      // onSuccess={handleAppleLogin}
      // onError={handleAppleLoginError}
      render={(renderProps) => (
        <TouchableOpacity
          onPress={renderProps.onClick}
          style={styles.appleButton}
        >
          <VText style={styles.buttonText}>Continue with Apple</VText>
          <ImageView
            source={Svgs.appleIcon}
            style={{ width: 28, height: 28, marginLeft: 10 }}
          />
        </TouchableOpacity>
      )}
    />
  );
};

const styles = StyleSheet.create({
  appleButton: {
    width: wp(375),
    height: hp(50),
    padding: 10,
    border: "1px solid #E6E8E7",
    borderRadius: fp(4),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    flexDirection: "row",
  },
  buttonText: {
    color: "#212427",
    fontWeight: "600",
    fontSize: fp(14),
    // marginRight:hp(4)
  },
});

export default AppleAuth;
